import { AppThunkDispatch } from '@Reducers/index';

import { CompanyApi } from '@ClientApi/company';
import { IAccountingConnectionModel, ICompanyModel, ICompanyPolicyModel } from '@Shared/models';

export const STORE_COMPANY = 'STORE_COMPANY';
export const STORE_COMPANY_POLICY = 'STORE_COMPANY_POLICY';
export const STORE_COMPANY_ACCOUNTING_INTEGRATION = 'STORE_COMPANY_ACCOUNTING_INTEGRATION';
export const STORE_COMPANY_CUSTOM_ONBOARDING_CHECKLIST = 'STORE_COMPANY_CUSTOM_ONBOARDING_CHECKLIST';
export const SET_LOADING_ACCOUNTING_INTEGRATION = 'SET_LOADING_ACCOUNTING_INTEGRATION';

export class StoreCompany {
  readonly type = STORE_COMPANY;

  constructor(public company: ICompanyModel) {}
}
export class SetLoadingAccountingIntegration {
  readonly type = SET_LOADING_ACCOUNTING_INTEGRATION;

  constructor(public loading: boolean) {}
}
export class StoreCompanyCustomOnboardingChecklist {
  readonly type = STORE_COMPANY_CUSTOM_ONBOARDING_CHECKLIST;
  constructor(public customOnboardingChecklist: ICompanyModel['custom_onboarding_checklist']) {}
}

export const getCompanyWithAccountingIntegration = () => async (dispatch: AppThunkDispatch) => {
  dispatch(new SetLoadingAccountingIntegration(true));
  try {
    const company = await CompanyApi.get(['accounting_integration']);
    // we sometimes use this to refresh the company state
    dispatch(new StoreCompany(company));
  } finally {
    dispatch(new SetLoadingAccountingIntegration(false));
  }
};

export const getCompanyWithCustomOnBoardingChecklist = () => async (dispatch: AppThunkDispatch) => {
  const company = await CompanyApi.get(['custom_onboarding_checklist']);
  dispatch(new StoreCompanyCustomOnboardingChecklist(company.custom_onboarding_checklist));
};

export const getCompanyWithMoreFields = (fields: (keyof ICompanyModel)[]) => async (dispatch: AppThunkDispatch) => {
  const hasAccountingIntegration = fields.includes('accounting_integration');

  if (hasAccountingIntegration) {
    dispatch(new SetLoadingAccountingIntegration(true));
  }
  try {
    const company = await CompanyApi.get(fields);
    dispatch(new StoreCompany(company));
  } finally {
    if (hasAccountingIntegration) {
      dispatch(new SetLoadingAccountingIntegration(false));
    }
  }
};

export class StoreCompanyPolicy {
  readonly type = STORE_COMPANY_POLICY;

  constructor(public companyPolicy: ICompanyPolicyModel) {}
}

export class StoreCompanyAccountingIntegration {
  readonly type = STORE_COMPANY_ACCOUNTING_INTEGRATION;

  constructor(public accountingIntegration: IAccountingConnectionModel) {}
}

export type CompanyAction =
  | StoreCompany
  | StoreCompanyPolicy
  | StoreCompanyAccountingIntegration
  | StoreCompanyCustomOnboardingChecklist
  | SetLoadingAccountingIntegration;
